module.exports = __webpack_public_path__ + "img/topIco.bc556dcf.png";